module.exports = __webpack_public_path__ + "static/media/intlopen-logo.a785b835.png";